import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { FormModal } from '@/components/ui/form-modal';
import { useNotificationDeliveries } from 'hooks/useNotification';
import { useNotificationDashboardFlag } from 'utils/featureFlags';
import { NotificationDeliveryReport } from './NotificationDeliveryReport';

/**
 * The delivery report as a modal, for senders looking at a notification from
 * their own list.
 *
 * The report itself lives in `NotificationDeliveryReport` and is shared with
 * the sends dashboard's detail page, so a modal is all this adds.
 */
export function NotificationDeliveryPanel({
  notificationId,
  title,
  onClose,
}: {
  notificationId: string;
  title: string;
  onClose: () => void;
}) {
  const { data, isLoading, isError } =
    useNotificationDeliveries(notificationId);
  const dashboardEnabled = useNotificationDashboardFlag();

  return (
    <FormModal
      open
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
      title="Delivery Report"
      description={title}
      widthClassName="tw:!max-w-5xl tw:sm:!max-w-5xl"
      footer={
        <>
          {dashboardEnabled ? (
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="tw:mr-auto"
              onClick={() => {
                window.open(
                  `/notifications/sends/${notificationId}`,
                  '_blank',
                  'noopener'
                );
              }}
            >
              <ExternalLink className="tw:h-4 tw:w-4" />
              Open full page
            </Button>
          ) : null}
          <Button type="button" size="sm" onClick={onClose}>
            Close
          </Button>
        </>
      }
    >
      <NotificationDeliveryReport
        notificationId={notificationId}
        data={data}
        isLoading={isLoading}
        isError={isError}
      />
    </FormModal>
  );
}

export default NotificationDeliveryPanel;
